"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.inspect = inspect;
const modulesParser = require("./npm-modules-parser");
const lockParser = require("./lock-parser");
const errors_1 = require("./errors");
const utils_1 = require("./utils");
async function inspect(root, targetFile, options = {}) {
    if (!targetFile) {
        throw (0, errors_1.MissingTargetFileError)(root);
    }
    const isLockFileBased = targetFile.endsWith('package-lock.json') ||
        targetFile.endsWith('yarn.lock') ||
        targetFile.endsWith('pnpm-lock.yaml');
    const getLockFileDeps = isLockFileBased && !options.traverseNodeModules;
    const depRes = getLockFileDeps
        ? await lockParser.parse(root, targetFile, options)
        : await modulesParser.parse(root, targetFile, options);
    let scannedProjects = [];
    if ((0, utils_1.isResDepGraph)(depRes)) {
        scannedProjects = [{ depGraph: depRes }];
    }
    else {
        scannedProjects = [{ depTree: depRes }];
    }
    return {
        plugin: {
            name: 'snyk-nodejs-lockfile-parser',
            runtime: process.version,
        },
        scannedProjects,
    };
}
//# sourceMappingURL=inspect.js.map